<template>
  <img class="responsive-img" :src="path" :alt="SVGFile" />
</template>

<script>
export default {
  name: "SVGImage",
  props: {
    SVGFile: String
  },
  computed: {
    path() {
      return require(`../assets/${this.SVGFile}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.responsive-img {
  max-width: 100%;
  height: auto;
}
</style>
